export default "__VITE_ASSET__J6$J0YEY__"